export default "__VITE_ASSET__a6eb6a06__"